module.exports = __webpack_public_path__ + "img/img (1).0a4cb389.jpeg";